// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"b0e8a052","875":"b37fad64","958":"2024b559"}[chunkId] + ".chunk.js";
};